<!-- 共通コンテンツトップ -->
<template>
  <div class="top">
    <h2 class="title" v-html="displayTitle"></h2>
    <p class="sub" v-html="displayText"></p>
  </div>
</template>
<script>
export default {
  props: {
    title: Array,
    text: Array,
  },
  computed: {
    displayTitle() {
      return this.title.join('<br>');
    },
    displayText() {
      return this.text.join('<br>');
    },
  },
};
</script>
